import { forwardRef } from "react";
import { Root } from "@radix-ui/react-label";
import { cva } from "class-variance-authority";
import { cn } from "../../lib/utils";

const labelVariants = cva(
  "text-sm font-medium leading-none peer-disabled:cursor-not-allowed peer-disabled:opacity-70"
);

const Label = forwardRef(
  ({ className, optional, children, ...props }, ref) => (
    <Root
      ref={ref}
      className={cn("text-sm font-medium text-neutral-10", className)}
      {...props}
    >
      {children}
      {optional && (
        <span className="ml-1 text-neutral-7 font-normal">(optional)</span>
      )}
    </Root>
  )
);
Label.displayName = Root.displayName;

export { Label };
